import type { McpPeriod } from "@/lib/api/organizations";

export const appKeys = {
  all: ["apps"] as const,
  list: (orgId: string) => ["apps", "list", orgId] as const,
  detail: (appId: string) => ["apps", "detail", appId] as const,
  questions: (appId: string) => ["apps", "questions", appId] as const,
  run: (appId: string, runId: string) =>
    ["apps", "events", appId, runId] as const,
  /** Every org's catalog: what a change to the platform's keys refreshes. */
  allProviders: ["apps", "providers"] as const,
  providers: (orgId: string) => ["apps", "providers", orgId] as const,
  keyUsage: (orgId: string, period?: McpPeriod) =>
    ["apps", "key-usage", orgId, ...(period ? [period] : [])] as const,
  mySpend: (orgId: string) => ["apps", "my-spend", orgId] as const,
  modelTables: (orgId: string, modelId: string) =>
    ["apps", "model-tables", orgId, modelId] as const,
  sourceTables: (orgId: string, modelId: string) =>
    ["apps", "sources", orgId, modelId] as const,
};
